"use client";

import NextError from "next/error";

export default function Error() {
    return <NextError statusCode={500} title={"Internal Server Error"} />;
}
